(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pp-review-language"] && !Shopify.designMode) return;
  try {
    function ppLocalizeReviewAction() {
    const label = document.getElementById('pp-review-copy')?.dataset.write;
    if (!label) return;
    document.querySelectorAll('.jdgm-widget').forEach(widget => {
      if (widget.dataset.ppLocalized) return;
      widget.dataset.ppLocalized = 'true';
      const update = () => {
        const button = widget.querySelector('.jdgm-write-rev-link');
        if (!button) return false;
        if (button.textContent.trim() === 'Write a review') button.textContent = label;
        return true;
      };
      if (update()) return;
      const observer = new MutationObserver(() => { if (update()) observer.disconnect(); });
      observer.observe(widget, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ppLocalizeReviewAction, { once: true });
  else ppLocalizeReviewAction();
  document.addEventListener('shopify:section:load', ppLocalizeReviewAction);
  } catch(e) { console.error(e); }
})();

})();
